import React from 'react'
import { Link } from 'react-router-dom'
import { Link as ScrollLink } from "react-scroll";

function Header() {
  return (
    <div>
         {/* Spinner Start */}
    {/* <div
      id="spinner"
      className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
    >
      <div
        className="spinner-border text-primary"
        style={{ width: "3rem", height: "3rem" }}
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div> */}
    {/* Spinner End */}

    {/* Topbar Start */}
    <div className="container-fluid bg-dark px-5 d-none d-lg-block">
      <div className="row gx-0">
        <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
          <div
            className="d-inline-flex align-items-center"
            style={{ height: 45 }}
          >
            <small className="me-3 text-light">
              <i className="fa fa-map-marker-alt me-2" />
              Plot No.2 Daria Near Railway Station Chandigarh
            </small>
            {/* <small className="me-3 text-light">
              <i className="fa fa-phone-alt me-2" />
              +919915-243-111
            </small> */}
  <small className="me-3 text-light">
  <i className="fa fa-phone-alt me-2" />
  <a
    className="text-light text-decoration-none"
    href="tel:+919915243111"
    onClick={(e) => {
      // fire conversion tracking but don't block default tel: navigation
      if (window.gtag) {
        window.gtag("event", "conversion", {
          send_to: "AW-17620937869/AOVPCMiI5bcbEI3ZqNJB",
          value: 1.0,
          currency: "INR",
        });
      }
      // allow href to continue naturally
    }}
  >
    +91 9915-243-111
  </a>
</small>

            <small className="text-light">
              <i className="fa fa-envelope-open me-2" />
support@urbaniasechalo.com
            </small>
          </div>
        </div>
        <div className="col-lg-4 text-center text-lg-end">
          <div
            className="d-inline-flex align-items-center"
            style={{ height: 45 }}
          >
            {/* <a
              className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
              to=""
            >
              <i className="fab fa-twitter fw-normal" />
            </a> */}
          <a
  className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
  href="https://www.facebook.com/share/1XQdB4ZYry/"
  target="_blank"
  rel="noopener noreferrer"
>
  <i className="fab fa-facebook-f fw-normal" />
</a>

<a
  className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
  href="https://wa.me/919915243111"
  target="_blank"
  rel="noopener noreferrer"
  onClick={() => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-17620937869/WBq0CNfi7LcbEI3ZqNJB",
      });
    }
  }}
>
  <i className="fab fa-whatsapp fw-normal" />
</a>

<a
  className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
  href="https://www.instagram.com/urbaniasechalo?igsh=bTRlNGU5OG9tZTB3"
  target="_blank"
  rel="noopener noreferrer"
>
  <i className="fab fa-instagram fw-normal" />
</a>
<a
              className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
              to="http://www.linkedin.com/in/deen-bandhu-gupta-185b13376"
            >
              <i className="fab fa-linkedin-in fw-normal" />
            </a>
            {/* <a
              className="btn btn-sm btn-outline-light btn-sm-square rounded-circle"
              to=""
            >
              <i className="fab fa-youtube fw-normal" />
            </a> */}
          </div>
        </div>
      </div>
    </div>
    {/* Topbar End */}
    {/* Navbar & Hero Start */}
    <div className="container-fluid position-relative p-0">
      <nav className="navbar navbar-expand-lg navbar-light px-4 px-lg-5 py-3 py-lg-0">
        <Link to="/" className="navbar-brand p-0">
          <h1 className="text-primary m-0">
            <i className="fa fa-map-marker-alt me-3" />
            Urbania Se Chalo
          </h1>
          {/* <img src="img/logo.png" alt="Logo"> */}
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
        >
          <span className="fa fa-bars" />
        </button>
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <div className="navbar-nav ms-auto py-0">
            {/* <Link to="/" className="nav-item nav-link">
              Home
            </Link> */}
                     <ScrollLink
  to="Home"
  smooth={true}
  duration={500}
  offset={-70} // adjust if you have a fixed navbar
  className="nav-item nav-link"
>
  Home
</ScrollLink>
            {/* <Link to="/About" className="nav-item nav-link">
              About
            </Link> */}
                                 <ScrollLink
  to="About"
  smooth={true}
  duration={500}
  offset={-70} // adjust if you have a fixed navbar
  className="nav-item nav-link"
>
  About
</ScrollLink>
            {/* <Link to="/Services" className="nav-item nav-link">
         Vehicles Services 
            </Link> */}

                                 <ScrollLink
  to="Vehicles"
  smooth={true}
  duration={500}
  offset={-70} // adjust if you have a fixed navbar
  className="nav-item nav-link"
>
           Vehicles Services 
</ScrollLink>

            {/* <Link to="/Packages" className="nav-item nav-link">
              Packages
            </Link> */}

         <ScrollLink
  to="Packages"
  smooth={true}
  duration={500}
  offset={-70} // adjust if you have a fixed navbar
  className="nav-item nav-link"
>
  Packages
</ScrollLink>

            <div className="nav-item dropdown">
              {/* <Link
                to="#"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Pages
              </Link> */}
              <div className="dropdown-menu m-0">
                <Link to="/Destination" className="dropdown-item">
                  Destination
                </Link>
                <Link to="/Booking" className="dropdown-item">
                  Booking
                </Link>
                <Link to="/Team" className="dropdown-item">
                  Travel Guides
                </Link>
                <Link to="/Testimonial" className="dropdown-item">
                  Testimonial
                </Link>
                <Link to="/Error" className="dropdown-item">
                  404 Page
                </Link>
              </div>
            </div>
         <ScrollLink
  to="contact"
  smooth={true}
  duration={500}
  offset={-70} // adjust if you have a fixed navbar
  className="nav-item nav-link"
>
  Contact
</ScrollLink>
          </div>
          {/* <Link to="/" className="btn btn-primary rounded-pill py-2 px-4">
            Register
          </Link> */}
        </div>
      </nav>
    </div>
    {/* Navbar & Hero End */}
    </div>
  )
}

export default Header
